<template>
    <div>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.buildingLandTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.longueur_terrain"
                                      prop="longueur_terrain"
                        >
                            <el-input v-model.number="post.longueur_terrain" type="longueur_terrain_a_batir">
                                <div slot="append">M</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.largeur_terrain"
                                      prop="largeur_terrain_a_batir"
                        >
                            <el-input v-model.number="post.largeur_terrain" type="largeur_terrain_a_batir">
                                <div slot="append">M</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.land')">
                            <el-checkbox v-model="post.avec_pente" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandWithSlope") }}</el-checkbox>
                            <el-checkbox v-model="post.viabilise" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandServiced") }}</el-checkbox>
                            <el-checkbox v-model="post.lotissement" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandAllotment") }}</el-checkbox>
                            <el-checkbox v-model="post.constructible" true-label="oui" false-label="non">{{$t("posts.edit.checkboxLandBuildable") }}</el-checkbox>
                        </el-form-item>
                    </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.exposition">
                                <el-select
                                        v-model="post.exposition"
                                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                        clearable
                                        filterable
                                >
                                    <el-option
                                            style="text-transform:capitalize"
                                            v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                            :key="expositionChoice"
                                            :label="expositionChoice"
                                            :value="expositionChoice"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    <el-col :span="24">
                        <el-form-item :label="$labels.belle_vue">
                            <el-radio v-model="post.belle_vue" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.belle_vue" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.environmentTitle')">
                            <el-select
                                    v-model="post.environnement"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :key="environnementChoice"
                                        :label="environnementChoice"
                                        :value="environnementChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.avec_vis_a_vis">
                            <el-radio v-model="post.avec_vis_a_vis" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.avec_vis_a_vis" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.certificat_urbanisme">
                            <el-radio v-model="post.certificat_urbanisme" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.certificat_urbanisme" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.shon"
                                      prop="shon"
                        >
                            <el-input  v-mask="'#################'" v-model.number="post.shon" type="shon">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.cos"
                                      prop="cos"
                        >
                            <el-input type="number" v-model="post.cos" step="0.01">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
        <ubi-panel>
            <ubi-form-group :title='$t("posts.propertyPartnerTitle")'>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerCompany')">
                            <el-input v-model="post.partenaire_foncier_societe">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerLastname')">
                            <el-input v-model="post.partenaire_foncier_nom">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerFirstname')">
                            <el-input v-model="post.partenaire_foncier_prenom">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerPhone')">
                            <el-input v-model.number="post.partenaire_foncier_telephone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import UbiFormGroup from '../../../../components/forms/FormGroup'

export default {
  name: 'PostEditImmoObject1310CmiModel',
  components: { UbiFormGroup },
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = [
      'mitoyennete',
      'chauffage_energie',
      'style_construction',
      'type_construction',
      'type_livraison',
      'exposition',
      'environnement',
      'mandat_statut',
      'modalites_recuperation_charges_locatives',
      'devise_iso_4217',
      'honoraires_payeurs'
    ]
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
